import { useMutation } from '@tanstack/react-query';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { getAuthHeaders } from '../../utils/authHeaders';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';

export type AttackRunInput = {
  targetId: string;
  targetType: TargetTypeType;
  signalId: string;
};

export type AttackRunResult = {
  success: boolean;
  executionId?: string;
  targetId: string;
  message?: string;
};

export async function runAttackForSignal({
  targetId,
  targetType,
  signalId,
}: AttackRunInput): Promise<AttackRunResult> {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(
    `${getCurrentGatewayUrl()}/ai/agents/attack/run`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
      body: JSON.stringify({
        targetId,
        targetType,
        vectorType: 'SIGNAL',
        vectorId: signalId,
        actorType: 'USER',
      }),
    },
  );

  if (!response.ok) {
    throw new Error('Failed to start attack');
  }

  return (await response.json()) as AttackRunResult;
}

export function useAttackRun() {
  return useMutation({
    mutationFn: runAttackForSignal,
  });
}
